module.exports = __webpack_public_path__ + "static/boogaloo-poster-28bd053f6d3803f4c242b3754a9e3773.jpg";